import type {
  RecommendationEntity,
  RecommendedProductEntity,
} from "@features/recommendations/domain";
import { only } from "@taager/reinforcements";
import type { RecommendationModel, RecommendedProductModel } from "../models";

export const mapRecommendation = (
  model: RecommendationModel,
): RecommendationEntity => ({
  id: model.id,
  accountManagerName: model.accountManagerName,
  createdAt: new Date(model.createdAt),
  recommendedProducts: model.recommendedProducts.map(mapRecommendedProduct),
});

const mapRecommendedProduct = (
  model: RecommendedProductModel,
): RecommendedProductEntity => {
  return {
    ...only(model, [
      "sku",
      "confirmationRate",
      "deliveryRate",
      "netDeliveryRate",
      "comment",
      "creativeLink",
    ]),
    minSellingPrice: model.originalPrice,
    id: model.productLegacyId,
    name: model.productName,
    isFavorited: model.isAddedToCatalog,
    image: model.productImage,
    recommendedPrice: model.recommendedAsp,
  };
};
